/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const errorEventClinicIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const errorEventContextLocationOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const errorEventContextProviderOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const errorEventContextSlotStartOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const errorEventContextVisitTypeOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const errorEventGroupIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const errorEventHttpStatusOneMin = -9007199254740991
export const errorEventHttpStatusOneMax = 9007199254740991

export const errorEventIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const errorEventOccurredAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)

export const ErrorEvent = zod.object({
  clinic: zod
    .object({
      id: zod.uuid().regex(errorEventClinicIdRegExp),
      name: zod.string(),
      slug: zod.string(),
    })
    .optional(),
  code: zod.string(),
  context: zod.object({
    location: zod.union([
      zod.object({
        id: zod.uuid().regex(errorEventContextLocationOneIdRegExp),
        name: zod.string(),
      }),
      zod.null(),
    ]),
    provider: zod.union([
      zod.object({
        id: zod.uuid().regex(errorEventContextProviderOneIdRegExp),
        name: zod.string(),
      }),
      zod.null(),
    ]),
    slotStart: zod.union([zod.iso.datetime({ offset: true }).regex(errorEventContextSlotStartOneRegExp), zod.null()]),
    visitType: zod.union([
      zod.object({
        id: zod.uuid().regex(errorEventContextVisitTypeOneIdRegExp),
        name: zod.string(),
      }),
      zod.null(),
    ]),
  }),
  groupId: zod.uuid().regex(errorEventGroupIdRegExp),
  httpStatus: zod.union([zod.int().min(errorEventHttpStatusOneMin).max(errorEventHttpStatusOneMax), zod.null()]),
  id: zod.uuid().regex(errorEventIdRegExp),
  message: zod.string(),
  occurredAt: zod.iso.datetime({ offset: true }).regex(errorEventOccurredAtRegExp),
  requestId: zod.string(),
  source: zod.string().nullable(),
  step: zod.enum(['pf_lookup', 'availability', 'hold', 'pf_write', 'pf_message', 'pf_login']),
})

export type ErrorEvent = zod.input<typeof ErrorEvent>
export type ErrorEventOutput = zod.output<typeof ErrorEvent>
